import React, { FunctionComponent } from 'react';

import Env from '../../config/env';
import IcDownload from '../../assets/icons/ic_download.svg';

interface Props {
  orderId: string;
  docType: string;
  serviceId: string;
}

const DownloadTicket: FunctionComponent<Props> = ({
  orderId,
  docType,
  serviceId,
}) => {
  return (
    <div className="itemTicket">
      <a
        href={`${Env.REQUEST_CAIPIRINHA_HOST}/v1/orders/${orderId}/tickets/${docType}/${serviceId}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <img
          src={IcDownload}
          alt="Baixar certificado"
          title="Baixar certificado"
        />
        <p>Baixar certificado</p>
      </a>
    </div>
  );
};

export default DownloadTicket;
